function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AllhomesListingCard } from '../allhomes-listing-card';
import AllhomesListingCardPaginator from './allhomes-listing-card-paginator';
import { mapGQLProps } from '../allhomes-listing-card-graphql';
import * as events from '../models/events';
import * as styles from './allhomes-listing-card-pane.styles';
import { MoreAgencyListingsDocument } from './more-agency-listings.query.generated';
import { MoreAgentListingsDocument } from './more-agent-listings.query.generated';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MAX_LISTINGS = 5000;
var Query = {
  agency: MoreAgencyListingsDocument,
  agent: MoreAgentListingsDocument
};
var AllhomesListingCardPane = props => {
  var _useAllhomesApi = useAllhomesApi(),
    apolloClient = _useAllhomesApi.apolloClient;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    moreListings = _useState2[0],
    setMoreListings = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useContext = useContext(MediaContext),
    desktop = _useContext.desktop;
  var cardContainer = useRef(null);
  var _useSendEvent = useSendEvent(),
    baseSendEvent = _useSendEvent.sendEvent;
  var sendEvent = (name, eventData) => baseSendEvent([events.tabsPrefix, name], eventData);
  var getMoreListings = () => {
    setLoading(true);
    apolloClient.query({
      query: Query[props.sourceType],
      variables: {
        id: props.sourceId,
        type: props.requestType.toUpperCase(),
        offset: props.initialSearchResult.length,
        limit: MAX_LISTINGS
      }
    }).then(_ref => {
      var _data$moreListings, _data$moreListings$no;
      var data = _ref.data;
      setMoreListings(data === null || data === void 0 ? void 0 : (_data$moreListings = data.moreListings) === null || _data$moreListings === void 0 ? void 0 : (_data$moreListings$no = _data$moreListings.nodes) === null || _data$moreListings$no === void 0 ? void 0 : _data$moreListings$no.map(mapGQLProps));
      if (cardContainer.current && desktop) {
        cardContainer.current.scrollIntoView();
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  };
  var showAll = () => {
    sendEvent(events.showMore);
    getMoreListings();
    props.onShowAll(props.id);
  };
  var showLess = () => {
    sendEvent(events.showLess);
    setMoreListings(null);
    props.onShowLess(props.id);
  };
  var handleCardClick = listingId => {
    var _props$listingCardCli;
    return (_props$listingCardCli = props.listingCardClicked) === null || _props$listingCardCli === void 0 ? void 0 : _props$listingCardCli.call(props, listingId);
  };
  return ___EmotionJSX("div", {
    css: styles.cardPane
  }, ___EmotionJSX("div", {
    css: styles.cards,
    key: props.id,
    ref: cardContainer
  }, [...props.initialSearchResult, ...(moreListings || [])].map(card => ___EmotionJSX(AllhomesListingCard, _extends({}, card, {
    key: card.id,
    onClick: handleCardClick,
    includeStructuredData: props.includeStructuredData
  })))), ___EmotionJSX(AllhomesListingCardPaginator, {
    showButton: props.initialSearchResult.length < props.totalListingsCount,
    allListingsShown: !loading && !!moreListings,
    loading: loading,
    onShowAll: showAll,
    onShowLess: showLess
  }));
};
export default AllhomesListingCardPane;